import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Tracking runs is fun! :D",
  "description": "",
  "published": "2010-04-30T00:00:00.000Z",
  "redirect_from": ["/blog/tracking-runs-is-fun-d/swizec/1322"],
  "categories": "GPS, life, running, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I finally figured out how to get sportypal working. Tomorrow I'm testing the hypotesis to make sure it wasn't a one-time fluke.`}</p>
    <p>{`The trick is to start it up when you're home. Then after the warmup walk kill it and open it again. This time GPS connect is instant.`}</p>
    <p>{`But the true lesson for today is that tracking runs is FUN. I even got a map and everything :D Sure it looks a bit weird where it decided I was running zigzag through houses and trees and cars and garages and pretty much everything at a sooper speed of `}<strong parentName="p">{`30! `}</strong>{`kilometers per hour.`}</p>
    <p>{`But hey, it's a blackberry not an iPhone (or Android), so I shan't complain. I'm just glad I can finally use this crap.`}</p>
    <p>{`Hmmm ... for some reason wordpress won't let me embed the map, so here's a screenshot.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/04/Screen-shot-2010-04-30-at-9.51.27-AM.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/04/Screen-shot-2010-04-30-at-9.51.27-AM.png",
          "alt": null,
          "title": "Screen shot 2010-04-30 at 9.51.27 AM"
        }}></img></a></p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/7512ac06-9c72-4184-92e8-eafed79ca5bd/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=7512ac06-9c72-4184-92e8-eafed79ca5bd",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      